// import React, { useEffect, useState } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Button,
//   Box,
//   Drawer,
//   IconButton,
//   List,
//   ListItemButton,
//   ListItemText,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import CloseIcon from "@mui/icons-material/Close";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import { AnimatePresence, motion } from "framer-motion";

// import InitialLogo from "../assests/Vedicwin_InitialLogo.webp";
// import ScrolledLogo from "../assests/VedicWin_Logo.webp";

// const MotionImg = motion(Box);

// export default function Navbar({
//   heroRef,
//   aboutRef,
//   programsRef,
//   facultyRef,
//   contactRef,
// }) {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [hasScrolled, setHasScrolled] = useState(false);

//   useEffect(() => {
//     const updateNavbar = () => setHasScrolled(window.scrollY > 24);
//     updateNavbar();
//     window.addEventListener("scroll", updateNavbar, { passive: true });
//     return () => window.removeEventListener("scroll", updateNavbar);
//   }, []);

//   const navItems = [
//     { label: "About", ref: aboutRef },
//     { label: "Programs", ref: programsRef },
//     { label: "Faculty", ref: facultyRef },
//     { label: "Contact", ref: contactRef },
//   ];

//   const scrollToSection = (ref) => {
//     ref.current?.scrollIntoView({
//       behavior: "smooth",
//       block: "start",
//     });
//     setMobileOpen(false);
//   };

//   // Which logo to show: the "initial" logo at the top, the "scrolled" logo once scrolled
//   const activeLogo = hasScrolled ? ScrolledLogo : InitialLogo;

//   return (
//     <AppBar
//       position="fixed"
//       elevation={0}
//       sx={{
//         backgroundColor: hasScrolled
//           ? "rgba(255, 255, 255, 0.94)"
//           : "transparent",
//         color: hasScrolled ? "#1f3a8a" : "#fff",
//         backdropFilter: hasScrolled ? "blur(16px)" : "none",
//         borderBottom: hasScrolled
//           ? "1px solid rgba(31, 58, 138, 0.09)"
//           : "1px solid transparent",
//         boxShadow: hasScrolled ? "0 12px 32px rgba(31, 58, 138, 0.10)" : "none",
//         transition:
//           "background-color 220ms ease, color 220ms ease, box-shadow 220ms ease, border-color 220ms ease",
//       }}
//     >
//       <Toolbar
//         sx={{
//           minHeight: { xs: 68, md: 60 },
//           px: { xs: 2, sm: 3, md: 4, lg: 6 },
//         }}
//       >
//         {/* LOGO CONTAINER */}
//         <Box
//           onClick={() => scrollToSection(heroRef)}
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             mr: "auto",
//             position: "relative",
//             height: { xs: 36, sm: 42, md: 40 },
//           }}
//         >
//           {/* Logo Image Mark — crossfades between the two logos on scroll */}
//           <AnimatePresence mode="wait">
//             <MotionImg
//               key={hasScrolled ? "scrolled-logo" : "initial-logo"}
//               component="img"
//               src={activeLogo}
//               alt="Vedic Win Logo"
//               initial={{ opacity: 0, y: -10, scale: 0.92 }}
//               animate={{ opacity: 1, y: 0, scale: 1 }}
//               exit={{ opacity: 0, y: 10, scale: 0.92 }}
//               transition={{ duration: 0.1, ease: "easeInOut" }}
//               sx={{
//                 height: { xs: 36, sm: 42, md: 35 },
//                 width: "auto",
//                 mr: { xs: 1.25, sm: 1.5 },
//                 objectFit: "contain",
               
//               }}
//             />
//           </AnimatePresence>
//         </Box>

//         {/* DESKTOP NAV ITEMS */}
//         <Box
//           sx={{
//             display: { xs: "none", md: "flex" },
//             gap: { md: 2, lg: 4 },
//             alignItems: "center",
//           }}
//         >
//           {navItems.map((item) => (
//             <Button
//               key={item.label}
//               disableRipple
//               onClick={() => scrollToSection(item.ref)}
//               sx={{
//                 color: hasScrolled ? "#1f3a8a" : "rgba(255,255,255,0.95)",
//                 textTransform: "none",
//                 fontWeight: 600,
//                 fontSize: "0.95rem",
//                 px: 0.5,
//                 minWidth: "auto",
//                 "&:hover": {
//                   background: "transparent",
//                   color: "#ff6b02",
//                 },
//               }}
//             >
//               {item.label}
//             </Button>
//           ))}
//         </Box>

//         {/* MOBILE MENU ICON */}
//         <IconButton
//           aria-label="open navigation"
//           onClick={() => setMobileOpen(true)}
//           sx={{
//             display: { xs: "inline-flex", md: "none" },
//             color: hasScrolled ? "#1f3a8a" : "#fff",
//           }}
//         >
//           <MenuIcon />
//         </IconButton>

//         {/* CALL TO ACTION BUTTON */}
//         <Button
//           onClick={() => scrollToSection(contactRef)}
//           endIcon={<ArrowForwardIcon sx={{ fontSize: "1rem !important" }} />}
//           sx={{
//             display: { xs: "none", md: "inline-flex" },
//             ml: { md: 3, lg: 4 },
//             px: 2.5,
//             py: 1,
//             borderRadius: "999px",
//             bgcolor: "#ff6b02",
//             color: "#fff",
//             textTransform: "none",
//             fontWeight: 700,
//             fontSize: "0.85rem",
//             boxShadow: "0 8px 18px rgba(255, 107, 2, 0.25)",
//             "&:hover": {
//               bgcolor: "#e05e00",
//               boxShadow: "0 8px 20px rgba(255, 107, 2, 0.35)",
//             },
//           }}
//         >
//           Free demo
//         </Button>
//       </Toolbar>

//       {/* MOBILE DRAWER */}
//       <Drawer
//         anchor="right"
//         open={mobileOpen}
//         onClose={() => setMobileOpen(false)}
//         PaperProps={{
//           sx: {
//             width: "min(78vw, 320px)",
//             p: 2,
//           },
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             m: "10px 5px 20px 10px",
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//             }}
//           >
//             <AnimatePresence mode="wait">
//               <MotionImg
//                 key={
//                   hasScrolled ? "drawer-scrolled-logo" : "drawer-initial-logo"
//                 }
//                 component="img"
//                 src={ScrolledLogo}
//                 alt="Vedic Win Logo"
//                 initial={{ opacity: 0, scale: 0.95 }}
//                 animate={{ opacity: 1, scale: 1 }}
//                 exit={{ opacity: 0, scale: 0.95 }}
//                 transition={{ duration: 0.2 }}
//                 sx={{
//                   height: 20,
//                   width: "auto",
//                   objectFit: "contain",
//                 }}
//               />
//             </AnimatePresence>
//           </Box>
//           <IconButton
//             aria-label="close navigation"
//             onClick={() => setMobileOpen(false)}
//           >
//             <CloseIcon />
//           </IconButton>
//         </Box>

//         <List>
//           {navItems.map((item) => (
//             <ListItemButton
//               key={item.label}
//               onClick={() => scrollToSection(item.ref)}
//               sx={{
//                 borderRadius: "12px",
//                 mb: 1,
//                 color: "#1f3a8a",
//                 "&:hover": {
//                   bgcolor: "#fff0e6",
//                   color: "#ff6b02",
//                 },
//               }}
//             >
//               <ListItemText
//                 primary={item.label}
//                 primaryTypographyProps={{
//                   fontWeight: 700,
//                 }}
//               />
//             </ListItemButton>
//           ))}
//         </List>
//       </Drawer>
//     </AppBar>
//   );
// }


// import React, { useEffect, useState, useRef } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Button,
//   Box,
//   Drawer,
//   IconButton,
//   List,
//   ListItemButton,
//   ListItemText,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import CloseIcon from "@mui/icons-material/Close";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import { motion } from "framer-motion";

// import InitialLogo from "../assests/vedicwin.png";
// import ScrolledLogo from "../assests/vedicwin copy.png";

// const MotionBox = motion(Box);

// export default function Navbar({
//   heroRef,
//   aboutRef,
//   programsRef,
//   facultyRef,
//   contactRef,
// }) {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [hasScrolled, setHasScrolled] = useState(false);
//   const tickingRef = useRef(false);

//   useEffect(() => {
//     // Hysteresis: switch ON after 60px, switch OFF only below 20px.
//     // Prevents rapid true/false flipping (and the resulting flicker)
//     // when the scroll position hovers near a single threshold.
//     const ON_THRESHOLD = 60;
//     const OFF_THRESHOLD = 20;

//     const updateNavbar = () => {
//       if (tickingRef.current) return;
//       tickingRef.current = true;
//       requestAnimationFrame(() => {
//         setHasScrolled((prev) => {
//           const y = window.scrollY;
//           if (!prev && y > ON_THRESHOLD) return true;
//           if (prev && y < OFF_THRESHOLD) return false;
//           return prev;
//         });
//         tickingRef.current = false;
//       });
//     };

//     updateNavbar();
//     window.addEventListener("scroll", updateNavbar, { passive: true });
//     return () => window.removeEventListener("scroll", updateNavbar);
//   }, []);

//   const navItems = [
//     { label: "About", ref: aboutRef },
//     { label: "Programs", ref: programsRef },
//     { label: "Faculty", ref: facultyRef },
//     { label: "Contact", ref: contactRef },
//   ];

//   const scrollToSection = (ref) => {
//     ref.current?.scrollIntoView({
//       behavior: "smooth",
//       block: "start",
//     });
//     setMobileOpen(false);
//   };

//   return (
//     <AppBar
//       position="fixed"
//       elevation={0}
//       sx={{
//         backgroundColor: hasScrolled
//           ? "rgba(255, 255, 255, 0.94)"
//           : "transparent",
//         color: hasScrolled ? "#1f3a8a" : "#fff",
//         backdropFilter: hasScrolled ? "blur(16px)" : "none",
//         borderBottom: hasScrolled
//           ? "1px solid rgba(31, 58, 138, 0.09)"
//           : "1px solid transparent",
//         boxShadow: hasScrolled ? "0 12px 32px rgba(31, 58, 138, 0.10)" : "none",
//         transition:
//           "background-color 220ms ease, color 220ms ease, box-shadow 220ms ease, border-color 220ms ease",
//       }}
//     >
//       <Toolbar
//         sx={{
//           minHeight: { xs: 68, md: 60 },
//           px: { xs: 2, sm: 3, md: 4, lg: 6 },
//         }}
//       >
//         {/* LOGO CONTAINER */}
//         <Box
//           onClick={() => scrollToSection(heroRef)}
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             mr: "auto",
//             position: "relative",
//             height: { xs: 36, sm: 42, md: 40 },
//             width: { xs: 120, sm: 140, md: 150 },
//           }}
//         >
//           {/* Both logos stay mounted; only opacity crossfades — no unmount gap, no flicker */}
//           <MotionBox
//             component="img"
//             src={InitialLogo}
//             alt="Vedic Win Logo"
//             animate={{ opacity: hasScrolled ? 0 : 1 }}
//             transition={{ duration: 0.2, ease: "easeInOut" }}
//             sx={{
//               position: "absolute",
//               left: 0,
//               top: "50%",
//               transform: "translateY(-50%)",
//               height: { xs: 36, sm: 42, md: 35 },
//               width: "auto",
//               objectFit: "contain",
//               pointerEvents: hasScrolled ? "none" : "auto",
//             }}
//           />
//           <MotionBox
//             component="img"
//             src={ScrolledLogo}
//             alt="Vedic Win Logo"
//             animate={{ opacity: hasScrolled ? 1 : 0 }}
//             transition={{ duration: 0.2, ease: "easeInOut" }}
//             sx={{
//               position: "absolute",
//               left: 0,
//               top: "50%",
//               transform: "translateY(-50%)",
//               height: { xs: 36, sm: 42, md: 35 },
//               width: "auto",
//               objectFit: "contain",
//               pointerEvents: hasScrolled ? "auto" : "none",
//             }}
//           />
//         </Box>

//         {/* DESKTOP NAV ITEMS */}
//         <Box
//           sx={{
//             display: { xs: "none", md: "flex" },
//             gap: { md: 2, lg: 4 },
//             alignItems: "center",
//           }}
//         >
//           {navItems.map((item) => (
//             <Button
//               key={item.label}
//               disableRipple
//               onClick={() => scrollToSection(item.ref)}
//               sx={{
//                 color: hasScrolled ? "#1f3a8a" : "rgba(255,255,255,0.95)",
//                 textTransform: "none",
//                 fontWeight: 600,
//                 fontSize: "0.95rem",
//                 px: 0.5,
//                 minWidth: "auto",
//                 "&:hover": {
//                   background: "transparent",
//                   color: "#ff6b02",
//                 },
//               }}
//             >
//               {item.label}
//             </Button>
//           ))}
//         </Box>

//         {/* MOBILE MENU ICON */}
//         <IconButton
//           aria-label="open navigation"
//           onClick={() => setMobileOpen(true)}
//           sx={{
//             display: { xs: "inline-flex", md: "none" },
//             color: hasScrolled ? "#1f3a8a" : "#fff",
//           }}
//         >
//           <MenuIcon />
//         </IconButton>

//         {/* CALL TO ACTION BUTTON */}
//         <Button
//           onClick={() => scrollToSection(contactRef)}
//           endIcon={<ArrowForwardIcon sx={{ fontSize: "1rem !important" }} />}
//           sx={{
//             display: { xs: "none", md: "inline-flex" },
//             ml: { md: 3, lg: 4 },
//             px: 2.5,
//             py: 1,
//             borderRadius: "999px",
//             bgcolor: "#ff6b02",
//             color: "#fff",
//             textTransform: "none",
//             fontWeight: 700,
//             fontSize: "0.85rem",
//             boxShadow: "0 8px 18px rgba(255, 107, 2, 0.25)",
//             "&:hover": {
//               bgcolor: "#e05e00",
//               boxShadow: "0 8px 20px rgba(255, 107, 2, 0.35)",
//             },
//           }}
//         >
//           Free demo
//         </Button>
//       </Toolbar>

//       {/* MOBILE DRAWER */}
//       <Drawer
//         anchor="right"
//         open={mobileOpen}
//         onClose={() => setMobileOpen(false)}
//         PaperProps={{
//           sx: {
//             width: "min(78vw, 320px)",
//             p: 2,
//           },
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             m: "10px 5px 20px 10px",
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center" }}>
//             <Box
//               component="img"
//               src={ScrolledLogo}
//               alt="Vedic Win Logo"
//               sx={{
//                 height: 20,
//                 width: "auto",
//                 objectFit: "contain",
//               }}
//             />
//           </Box>
//           <IconButton
//             aria-label="close navigation"
//             onClick={() => setMobileOpen(false)}
//           >
//             <CloseIcon />
//           </IconButton>
//         </Box>

//         <List>
//           {navItems.map((item) => (
//             <ListItemButton
//               key={item.label}
//               onClick={() => scrollToSection(item.ref)}
//               sx={{
//                 borderRadius: "12px",
//                 mb: 1,
//                 color: "#1f3a8a",
//                 "&:hover": {
//                   bgcolor: "#fff0e6",
//                   color: "#ff6b02",
//                 },
//               }}
//             >
//               <ListItemText
//                 primary={item.label}
//                 primaryTypographyProps={{
//                   fontWeight: 700,
//                 }}
//               />
//             </ListItemButton>
//           ))}
//         </List>
//       </Drawer>
//     </AppBar>
//   );
// }


import React, { useEffect, useState, useRef } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { motion } from "framer-motion";

import InitialLogo from "../assests/vedicwin.webp";
import ScrolledLogo from "../assests/vedicwin copy.webp";

const MotionBox = motion(Box);

export default function Navbar({
  heroRef,
  aboutRef,
  programsRef,
  facultyRef,
  contactRef,
}) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const tickingRef = useRef(false);

  useEffect(() => {
    // Hysteresis: switch ON after 60px, switch OFF only below 20px.
    // Prevents rapid true/false flipping (and the resulting flicker)
    // when the scroll position hovers near a single threshold.
    const ON_THRESHOLD = 60;
    const OFF_THRESHOLD = 20;

    const updateNavbar = () => {
      if (tickingRef.current) return;
      tickingRef.current = true;
      requestAnimationFrame(() => {
        setHasScrolled((prev) => {
          const y = window.scrollY;
          if (!prev && y > ON_THRESHOLD) return true;
          if (prev && y < OFF_THRESHOLD) return false;
          return prev;
        });
        tickingRef.current = false;
      });
    };

    updateNavbar();
    window.addEventListener("scroll", updateNavbar, { passive: true });
    return () => window.removeEventListener("scroll", updateNavbar);
  }, []);

  const navItems = [
    { label: "About", ref: aboutRef },
    { label: "Programs", ref: programsRef },
    { label: "Faculty", ref: facultyRef },
    { label: "Contact", ref: contactRef },
  ];

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    setMobileOpen(false);
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: hasScrolled
          ? "rgba(255, 255, 255, 0.94)"
          : "transparent",
        color: hasScrolled ? "#1f3a8a" : "#fff",
        backdropFilter: hasScrolled ? "blur(16px)" : "none",
        borderBottom: hasScrolled
          ? "1px solid rgba(31, 58, 138, 0.09)"
          : "1px solid transparent",
        boxShadow: hasScrolled ? "0 12px 32px rgba(31, 58, 138, 0.10)" : "none",
        transition:
          "background-color 220ms ease, color 220ms ease, box-shadow 220ms ease, border-color 220ms ease",
      }}
    >
      <Toolbar
        sx={{
          // Taller toolbar gives the bigger logo room to breathe
          minHeight: { xs: 84, md: 76 },
          py: 1,
          px: { xs: 2, sm: 3, md: 4, lg: 6 },
        }}
      >
        {/* LOGO CONTAINER */}
        <Box
          onClick={() => scrollToSection(heroRef)}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            mr: "auto",
            position: "relative",
            // Bigger box to match the bigger logo images below
            height: { xs: 58, sm: 66, md: 70 },
            width: { xs: 160, sm: 180, md: 200 },
          }}
        >
          {/* Both logos stay mounted; only opacity crossfades — no unmount gap, no flicker */}
          <MotionBox
            component="img"
            src={InitialLogo}
            alt="Vedic Win Logo"
            animate={{ opacity: hasScrolled ? 0 : 1 }}
            transition={{ duration: 0.2, ease: "easeInOut" }}
            sx={{
              position: "absolute",
              left: 0,
              top: "50%",
              transform: "translateY(-50%)",
              // Increased from {xs:36, sm:42, md:35} for better visual presence
              height: { xs: 54, sm: 62, md: 80 },
              width: "auto",
              objectFit: "contain",
              pointerEvents: hasScrolled ? "none" : "auto",
            }}
          />
          <MotionBox
            component="img"
            src={ScrolledLogo}
            alt="Vedic Win Logo"
            animate={{ opacity: hasScrolled ? 1 : 0 }}
            transition={{ duration: 0.2, ease: "easeInOut" }}
            sx={{
              position: "absolute",
              left: 0,
              top: "50%",
              transform: "translateY(-50%)",
              height: { xs: 54, sm: 62, md: 70 },
              width: "auto",
              objectFit: "contain",
              pointerEvents: hasScrolled ? "auto" : "none",
            }}
          />
        </Box>

        {/* DESKTOP NAV ITEMS */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            gap: { md: 2, lg: 4 },
            alignItems: "center",
          }}
        >
          {navItems.map((item) => (
            <Button
              key={item.label}
              disableRipple
              onClick={() => scrollToSection(item.ref)}
              sx={{
                color: hasScrolled ? "#1f3a8a" : "rgba(255,255,255,0.95)",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.95rem",
                px: 0.5,
                minWidth: "auto",
                "&:hover": {
                  background: "transparent",
                  color: "#ff6b02",
                },
              }}
            >
              {item.label}
            </Button>
          ))}
        </Box>

        {/* MOBILE MENU ICON */}
        <IconButton
          aria-label="open navigation"
          onClick={() => setMobileOpen(true)}
          sx={{
            display: { xs: "inline-flex", md: "none" },
            color: hasScrolled ? "#1f3a8a" : "#fff",
          }}
        >
          <MenuIcon />
        </IconButton>

        {/* CALL TO ACTION BUTTON */}
        <Button
          onClick={() => scrollToSection(contactRef)}
          endIcon={<ArrowForwardIcon sx={{ fontSize: "1rem !important" }} />}
          sx={{
            display: { xs: "none", md: "inline-flex" },
            ml: { md: 3, lg: 4 },
            px: 2.5,
            py: 1,
            borderRadius: "999px",
            bgcolor: "#ff6b02",
            color: "#fff",
            textTransform: "none",
            fontWeight: 700,
            fontSize: "0.85rem",
            boxShadow: "0 8px 18px rgba(255, 107, 2, 0.25)",
            "&:hover": {
              bgcolor: "#e05e00",
              boxShadow: "0 8px 20px rgba(255, 107, 2, 0.35)",
            },
          }}
        >
          Free demo
        </Button>
      </Toolbar>

      {/* MOBILE DRAWER */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        PaperProps={{
          sx: {
            width: "min(78vw, 320px)",
            p: 2,
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            m: "10px 5px 20px 10px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              component="img"
              src={ScrolledLogo}
              alt="Vedic Win Logo"
              sx={{
                height: 26,
                width: "auto",
                objectFit: "contain",
              }}
            />
          </Box>
          <IconButton
            aria-label="close navigation"
            onClick={() => setMobileOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <List>
          {navItems.map((item) => (
            <ListItemButton
              key={item.label}
              onClick={() => scrollToSection(item.ref)}
              sx={{
                borderRadius: "12px",
                mb: 1,
                color: "#1f3a8a",
                "&:hover": {
                  bgcolor: "#fff0e6",
                  color: "#ff6b02",
                },
              }}
            >
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontWeight: 700,
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </Drawer>
    </AppBar>
  );
}